import * as s from '../Eliminator/Admin/EliminatorRegisterPlayers.scss'
import PlayerListItem from '../Player/PlayerListItem'
import FontAwesomeIcon from '@severed-links/common.font-awesome-icon'
import SeasonSelector from '../Football/SeasonSelector'
import Confirm from '@severed-links/common.confirm'
import { Button, FormControl, ListGroup } from 'react-bootstrap'
import terminatorErrorMessage from './terminatorErrorMessage'
import useTerminatorAdminSeason from './useTerminatorAdminSeason'
import React, { useEffect, useState } from 'react'
import { getMainPageData } from '@severed-links/common.redherrings-reducers/terminator'
import { getPlayers, updateRegistrationStatus, updateRegistrationPayment } from '@severed-links/common.redherrings-reducers/terminatorAdmin'
import { Alert } from 'react-bootstrap'

const RegisterPlayerButton = ({ title = '', isChecked = false, disabled = false, onClick }) => (
    <Button size='sm' className={s.registrationButton} disabled={disabled}
        onClick={() => onClick(!isChecked)} variant={disabled ? 'light' : isChecked ? 'success' : 'danger'}>
        <FontAwesomeIcon className={s.buttonIcon} name={isChecked ? 'check' : 'times'} />
        <div className={s.buttonTitle}>{!isChecked ? 'not ' : ''}{title}</div>
    </Button>
)

const TerminatorRegisterPlayers = () => {
  const { dispatch, seasons, seasonId, setSelected } = useTerminatorAdminSeason()
  const [filter, setFilter] = useState('')
  const [players, setPlayers] = useState([])
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  const [refresh, setRefresh] = useState(0)
  useEffect(() => {
    setPlayers([])
    setError('')
    if (!seasonId) return
    let active = true
    dispatch(getPlayers(seasonId)).then(action => {
      if (action.error || action.payload?.messageType === 'error') throw new Error(action.payload?.response?.message || action.payload?.message || 'Unable to load players.')
      if (active) setPlayers(action.payload.players)
    }).catch(error => { if (active) setError(terminatorErrorMessage(error)) })
    return () => { active = false }
  }, [dispatch, seasonId, refresh])
  const toggle = async (player, payment = false) => {
    if (busy) return
    setBusy(true)
    setError('')
    try {
      const action = await dispatch(payment ? updateRegistrationPayment({ seasonId, playerId: player.playerId, isPaid: !player.isPaid }) : updateRegistrationStatus({ seasonId, playerId: player.playerId, isRegistered: !player.isRegistered }))
      if (action.error || action.payload?.messageType === 'error') throw new Error(action.payload?.response?.message || action.payload?.message || 'Unable to update registration.')
      setRefresh(value => value + 1)
      dispatch(getMainPageData())
    } catch (error) { setError(terminatorErrorMessage(error)) }
    setBusy(false)
  }
  const visiblePlayers = players.filter(player => `${player.firstName} ${player.lastName}`.toLowerCase().includes(filter.trim().toLowerCase()))
  const season = seasons.find(item => item.seasonId === seasonId) || {}
  const seasonName = season.seasonName || ''
  const registeredCount = players.filter(p => p.isRegistered).length
  const paidCount = players.filter(p => p.isRegistered && p.isPaid).length
  const unpaidCount = registeredCount - paidCount
    return (
        <div className={s.container}>
            {error ? <Alert variant='danger'>{error}</Alert> : null}
            <section className={s.pageHeader}>
                <div className={s.headerCopy}>
                    <div className={s.eyebrow}>Terminator Admin</div>
                    <h2 className={s.title}>Register Players</h2>
                    <div className={s.subtitle}>{seasonName} manual registration and payment status</div>
                </div>
                <div className={s.headerActions}>
                    <SeasonSelector seasons={seasons} season={season} onSelect={name => setSelected(seasons.find(item => item.seasonName === name)?.seasonId)} />
                </div>
            </section>

            <section className={s.summaryGrid}>
                <div className={s.summaryPill}>
                    <span>{players.length}</span>
                    players
                </div>
                <div className={s.summaryPill}>
                    <span>{registeredCount}</span>
                    registered
                </div>
                <div className={s.summaryPill}>
                    <span>{paidCount}</span>
                    paid
                </div>
                <div className={s.summaryPill + (unpaidCount ? ` ${s.warning}` : '')}>
                    <span>{unpaidCount}</span>
                    registered, unpaid
                </div>
            </section>

            <section className={s.filterBar}>
                <div>
                    <label htmlFor='terminator-registration-player-filter'>Find Player</label>
                    <div className={s.filterInput}>
                        <FontAwesomeIcon name='magnifying-glass' />
                        <FormControl id='terminator-registration-player-filter'
                            placeholder='Type a first or last name'
                            value={filter}
                            onChange={e => setFilter(e.target.value)} />
                        {filter ?
                        <Button variant='light' title='clear filter' onClick={() => setFilter('')}>
                            <FontAwesomeIcon name='xmark' />
                        </Button>
                        : null}
                    </div>
                </div>
                <div className={s.filterCount}>
                    {visiblePlayers.length} of {players.length} shown
                </div>
            </section>

            <section className={s.registrationCard}>
                <div className={s.listHeader}>
                    <div>Player</div>
                    <div>Status</div>
                </div>
                <ListGroup className={s.registrationList}>
                {visiblePlayers.map(p =>
                <PlayerListItem player={p}
                    className={s.playerRow}
                    rightDetail={<div className={s.rightDetail}>
                        <RegisterPlayerButton title='registered' isChecked={p.isRegistered} disabled={busy}
                            onClick={() => { if (window.confirm(`${p.isRegistered ? 'Unregister' : 'Register'} ${p.firstName} ${p.lastName}?`)) toggle(p) }} />
                        <Confirm disabled={busy || !p.isRegistered} variant={p.isPaid ? 'success' : 'danger'} size='sm'
                            buttonClassName={s.registrationButton} buttonIcon={p.isPaid ? 'check' : 'times'} buttonText={p.isPaid ? 'paid' : 'not paid'}
                            heading='Update Player Payment' confirmText={p.isPaid ? 'Mark unpaid' : 'Mark paid'}
                            body={`Mark ${p.firstName} ${p.lastName} ${p.isPaid ? 'unpaid' : 'paid'}? This records a balance correction; no money is transferred or refunded.`}
                            onConfirm={() => toggle(p, true)} />
                    </div>}
                    key={`registration-${seasonName}-player-${p.playerId}`} />
                )}
                {!visiblePlayers.length ?
                <div className={s.emptyState}>No players match that filter.</div>
                : null}
                </ListGroup>
            </section>
        </div>
    )
}

export default TerminatorRegisterPlayers
